export const PRODUCTS = [
  { id: "mutuo", label: "Mutuo", color: "#2563EB" },
  { id: "prestito", label: "Prestito", color: "#D97706" },
  { id: "cqs", label: "Cessione del quinto", color: "#7C3AED" },
  { id: "polizza", label: "Polizza", color: "#059669" },
  { id: "conto", label: "Conto corrente", color: "#0891B2" },
  { id: "altro", label: "Altro", color: "#64748B" },
];
export const productOf = (id) => PRODUCTS.find((p) => p.id === id) || PRODUCTS.find((p) => p.id === "altro");

export const STAGES = [
  { id: "nuovo", label: "Nuovo contatto", cls: "bg-sky-50 border-sky-200 text-sky-700" },
  { id: "istruttoria", label: "In istruttoria", cls: "bg-amber-50 border-amber-200 text-amber-700" },
  { id: "documenti", label: "Raccolta documenti", cls: "bg-purple-50 border-purple-200 text-purple-700" },
  { id: "delibera", label: "Delibera", cls: "bg-indigo-50 border-indigo-200 text-indigo-700" },
  { id: "erogato", label: "Erogato / Chiuso", cls: "bg-emerald-50 border-emerald-200 text-emerald-700" },
  { id: "perso", label: "Perso", cls: "bg-rose-50 border-rose-200 text-rose-700" },
];
export const stageOf = (id) => STAGES.find((s) => s.id === id) || STAGES[0];

export const STATUSES = [
  { id: "lead", label: "Lead" },
  { id: "cliente", label: "Cliente" },
  { id: "ex_cliente", label: "Ex cliente" },
];
export const statusLabel = (id) => STATUSES.find((s) => s.id === id)?.label || id;

export const INTERACTION_TYPES = [
  { id: "chiamata", label: "Chiamata" },
  { id: "whatsapp", label: "WhatsApp" },
  { id: "email", label: "Email" },
  { id: "sms", label: "SMS" },
  { id: "incontro", label: "Incontro" },
  { id: "nota", label: "Nota" },
];

export const fmtEur = (v) =>
  v == null || v === "" ? "—" : new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v);
export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
export const fmtTime = (s) => new Date(s).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("it-IT") : "—");

export const toLocalInput = (d) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};

export const urgency = (due) => {
  const d = new Date(due);
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  if (d < start) return "scaduto";
  if (d < end) return "oggi";
  return "futuro";
};

export const intlPhone = (phone = "") => {
  let d = phone.replace(/[^\d+]/g, "");
  if (d.startsWith("+")) return d.slice(1);
  if (d.startsWith("00")) return d.slice(2);
  if (d.startsWith("3") || d.startsWith("0")) return "39" + d;
  return d;
};

const enc = encodeURIComponent;
export const waLink = (phone, text) => `https://wa.me/${intlPhone(phone)}?text=${enc(text || "")}`;
export const smsLink = (phone, text) => `sms:${phone}?body=${enc(text || "")}`;
export const telLink = (phone) => `tel:${phone}`;
export const gmailLink = (to, subject, body) =>
  `https://mail.google.com/mail/?view=cm&fs=1&to=${enc(to || "")}&su=${enc(subject || "")}&body=${enc(body || "")}`;
export const outlookLink = (to, subject, body) =>
  `https://outlook.office.com/mail/deeplink/compose?to=${enc(to || "")}&subject=${enc(subject || "")}&body=${enc(body || "")}`;
export const mailtoLink = (to, subject, body) => `mailto:${to || ""}?subject=${enc(subject || "")}&body=${enc(body || "")}`;

const gcalDate = (d) => d.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
export const gcalLink = (r) => {
  const start = new Date(r.due_at);
  const end = new Date(start.getTime() + (r.duration || 15) * 60000);
  const details = [r.reason, r.client_phone && `Tel: ${r.client_phone}`, r.client_email && `Email: ${r.client_email}`].filter(Boolean).join("\n");
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${enc(`Richiamo: ${r.client_name}`)}&dates=${gcalDate(start)}/${gcalDate(end)}&details=${enc(details)}`;
};

export const TEMPLATE_VARS = ["nome", "cognome", "prodotto", "importo", "data_richiamo"];
